import React from 'react';

import { css } from '@emotion/core';

import { disabledColor, unit } from '@zego/theme';

import RegularText from '@zego/components/atoms/RegularText';
import Spacer from '@zego/components/atoms/Spacer';
import View from '@zego/components/atoms/View';
import ContentContainer from '@zego/components/ContentContainer';
import SectionDisplay from '@zego/components/SectionDisplay';
import ZegoCopyright from '@zego/components/ZegoCopyright';

const LandingPageFooter = ({ disclaimerText }) => (
  <>
    <View
      css={{
        width: '50%',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: unit(6),
      }}
    >
      <RegularText
        css={{
          fontSize: 10,
          lineHeight: '12px',
          textAlign: 'center',
          color: disabledColor(6),
        }}
      >
        {disclaimerText}
      </RegularText>
    </View>
    <SectionDisplay>
      <ContentContainer>
        <div
          css={css`
            display: grid;
            grid-column-gap: 20px;
            grid-row-gap: ${unit(4)}px;
            grid-auto-rows: auto;
            grid-template-columns: [aside-start main-start] 1fr [aside-end main-end];
            @media screen and (min-width: 768px) {
              grid-template-columns: [aside-start] 2fr [aside-end main-start] 10fr [main-end];
            }
          `}
        >
          <div
            css={css`
              grid-column: aside;
            `}
          >
            <RegularText
              css={{
                color: disabledColor(10),
                fontSize: 10,
                lineHeight: '13px',
              }}
            >
              <ZegoCopyright />
            </RegularText>
          </div>

          <div
            css={css`
              grid-column: main;
            `}
          >
            <RegularText css={{ fontSize: 10, lineHeight: '13px' }}>
              Zego is a trading name of Extracover Limited, which is authorised
              and regulated by the Financial Conduct Authority.
              <br />
              (FRN: 757871).
            </RegularText>

            <Spacer height={unit(1)} />

            <RegularText css={{ fontSize: 10, lineHeight: '13px' }}>
              ExtraCover Limited is registered in England and Wales, No
              10128841. Registered address: 5th floor, FORA Shoreditch, 21-33
              Great Eastern St, Hackney, London EC2A 3EJ.
            </RegularText>
          </div>
        </div>
      </ContentContainer>
    </SectionDisplay>
  </>
);

export default LandingPageFooter;
